export default __webpack_public_path__ + "static/media/plant-highlight.855d8d37.svg";